// The visitor's analytics/ads tracking choice.
//
// Kept in a cookie rather than localStorage: public/index.html clears
// localStorage on every load, and its inline loader reads this same cookie to
// decide whether Google Analytics / Meta Pixel may start.
const COOKIE = "mb_consent";
const MAX_AGE = 60 * 60 * 24 * 180; // ask again after ~6 months
const TRACKING_COOKIE = /^(_ga|_gid|_gat|_gcl|_fbp|_fbc)/;

// Dispatched on window to reopen the banner (footer "Cookie settings").
export const OPEN_EVENT = "mb:open-consent";

export function getConsent() {
  const m = document.cookie.match(/(?:^|; )mb_consent=(granted|denied)/);
  return m ? m[1] : null;
}

function setConsent(value) {
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE}=${value}; path=/; max-age=${MAX_AGE}; SameSite=Lax${secure}`;
}

// GA / Meta set their cookies on the registrable domain, so expire each one on
// the current host and every parent domain.
export function clearTrackingCookies() {
  const parts = window.location.hostname.split(".");
  const domains = [""];
  for (let i = 0; i < parts.length - 1; i += 1) domains.push(`.${parts.slice(i).join(".")}`);

  document.cookie.split("; ").forEach((c) => {
    const name = c.split("=")[0];
    if (!TRACKING_COOKIE.test(name)) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; path=/; max-age=0${d ? `; domain=${d}` : ""}`;
    });
  });
}

export function grantConsent() {
  setConsent("granted");
  if (window.mbLoadTracking) window.mbLoadTracking();
}

export function denyConsent() {
  const wasGranted = getConsent() === "granted";
  setConsent("denied");
  if (wasGranted) {
    // Withdrawal: the scripts are already running in this page, so reload
    // into a tracking-free page. They rewrite their cookies while the page
    // unloads, so CookieConsent clears them again once the new page is up.
    clearTrackingCookies();
    window.location.reload();
  }
}
